module.exports = __webpack_public_path__ + "static/img/yx-shi.540d26a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yx-shi.png
// module id = sSGe
// module chunks = 0